import { useSelector } from 'react-redux';
import { selectApplication } from '../store/selectors/applicationSelectors';

const useApplicationFundingData = () => {
  const Application = useSelector(selectApplication);

  const { ApplicationFunding } = Application;

  return { ApplicationFunding };
};

export default useApplicationFundingData;
